import React, { useEffect } from "react";

import type { InviteTheme } from "../../types/invite";

const FONT_HREF: Record<InviteTheme, string> = {
  gold: "https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;1,500&family=DM+Sans:wght@400;500;600&display=swap",
  neon: "https://fonts.googleapis.com/css2?family=Anton&family=DM+Sans:wght@400;500;600&display=swap",
};

const THEME_COLOR: Record<InviteTheme, string> = { gold: "#120D12", neon: "#07050B" };

/** Load the theme's fonts and tint the mobile browser bar while an invite page is open. */
export function useInviteTheme(theme: InviteTheme | undefined, title?: string): void {
  useEffect(() => {
    if (!theme) return undefined;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = FONT_HREF[theme];
    document.head.appendChild(link);

    let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    const previousColor = meta?.content;
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "theme-color";
      document.head.appendChild(meta);
    }
    meta.content = THEME_COLOR[theme];

    return () => {
      link.remove();
      if (meta && previousColor !== undefined) meta.content = previousColor;
    };
  }, [theme]);

  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}

export const InviteBrand: React.FC<{ brand?: string; logoUrl?: string | null }> = ({ brand, logoUrl }) => {
  if (logoUrl) {
    return (
      <div className="inv-logo">
        <img src={logoUrl} alt={brand || ""} />
      </div>
    );
  }
  if (!brand) return null;
  return <span className="inv-brand">{brand}</span>;
};
